import { createFileRoute } from "@tanstack/react-router";
import DiagnosticadorLocales from "@/pages/DiagnosticadorLocales";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/en/retail-location-analysis")({
  head: () => pageHead("locationAnalysis", "en", { links: false }),
  component: DiagnosticadorLocales,
});
